import React, { memo } from "react";
import { FC } from "react";

type Props = {
  currency: string;
  name: string;
  onClick: () => void;
  isActive?: boolean;
};

const CryptoItemComponent: FC<Props> = ({ currency, name, onClick, isActive }) => {
  return (
    <div
      style={{
        height: "68px",
        padding: "14px",
        display: "flex",
        alignItems: "center",
        gap: "14px",
        borderBottom: "1px solid #D7D7D7",
        backgroundColor: isActive ? "#EDEDED" : undefined,
      }}
      onClick={onClick}
    >
      <div style={{ display: "flex", alignItems: "center", flex: 1, gap: "14px", overflow: "hidden" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "40px",
            maxWidth: "40px",
            height: "40px",
            borderRadius: "8px",
            backgroundColor: "#E41E1F",
          }}
        >
          <img style={{ width: "26px", height: "26px" }} src={`/img/icons_new/${currency.toLowerCase().split("-")[0]}_coin.svg`} alt="" />
        </div>
        <span
          style={{
            fontSize: "18px",
            lineHeight: "145%",
            fontWeight: 800,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            letterSpacing: "-0.36px",
          }}
        >
          {name}
        </span>
      </div>
      <span
        style={{
          fontSize: "18px",
          lineHeight: "145%",
          fontWeight: 800,
          letterSpacing: "-0.36px",
          color: "#8F8F8F",
        }}
      >
        {currency}
      </span>
    </div>
  );
};

export const CryptoItem = memo(CryptoItemComponent);
